import React from 'react'
import styled from 'react-emotion'
import {
  color,
  fontSize,
  fontWeight,
  gradientStart,
  gradientEnd,
  mediaUp,
  padding,
  spacer
} from 'stylist'

const GroupHeading = styled.h3`
  position: relative;
  flex-basis: 100%;
  margin-bottom: ${spacer(4)};

  @supports (display: grid) {
    grid-column: 1 / -1;
    flex-basis: unset;
    margin-bottom: 0;
  }

  ${mediaUp('md')} {
    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background-color: ${gradientEnd('green')};
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`

const Content = styled.div`
  text-align: center;
  text-transform: uppercase;
  z-index: 1;
  position: relative;
  margin: 0 auto;
  letter-spacing: 0.04rem;
  background: linear-gradient(
    to right,
    ${gradientStart('green')} 0,
    ${gradientEnd('green')} 100%
  );

  ${mediaUp('md')} {
    max-width: 420px;
    border-left: 30px solid ${color('white')};
    border-right: 30px solid ${color('white')};
  }

  ${fontSize('s')};
  ${fontWeight('bold')};
  ${padding('xs')};
`

const GroupHeader = ({ children }) => (
  <GroupHeading>
    <Content>{children}</Content>
  </GroupHeading>
)

export default GroupHeader



// WEBPACK FOOTER //
// ./src/routes/home/components/GroupHeader.js